import React, { useState } from 'react';
import Header from './Header';
import Hero from './Hero';
import ImpactMetrics from './ImpactMetrics';
import ProblemSolution from './ProblemSolution';
import ATSScorePromo from './ATSScorePromo';
import Pricing from './Pricing';
import Footer from './Footer';
import RequestDemoModal from './RequestDemoModal';

const LandingPage: React.FC = () => {
  const [isDemoModalOpen, setDemoModalOpen] = useState(false);

  const openDemoModal = () => setDemoModalOpen(true);
  const closeDemoModal = () => setDemoModalOpen(false);

  return (
    <>
      <Header onRequestDemo={openDemoModal} />
      <Hero />
      <ImpactMetrics />
      <ProblemSolution />
      <ATSScorePromo />
      <Pricing />
      <Footer />

      {/* Modal */}
      <RequestDemoModal isOpen={isDemoModalOpen} onClose={closeDemoModal} />
    </>
  );
};

export default LandingPage;
